/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
/**
* CSS Custom Properties
*
* These properties can be overridden using the component's tag as selector.
*
* @prop --calcite-input-message-spacing-value: The top margin spacing above the component.
*/
:host {
  box-sizing: border-box;
  display: flex;
  block-size: auto;
  inline-size: 100%;
  align-items: center;
  font-weight: var(--calcite-font-weight-medium);
  color: var(--calcite-color-text-1);
  opacity: 1;
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s;
  --calcite-input-message-spacing-value: 0.25rem;
  margin-block-start: var(--calcite-input-message-spacing-value);
}

.calcite-input-message-icon {
  pointer-events: none;
  display: inline-flex;
  flex-shrink: 0;
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s;
  margin-inline-end: 0.5rem;
}

:host([status=invalid]) .calcite-input-message-icon {
  color: var(--calcite-color-status-danger);
}

:host([status=warning]) .calcite-input-message-icon {
  color: var(--calcite-color-status-warning);
}

:host([status=valid]) .calcite-input-message-icon {
  color: var(--calcite-color-status-success);
}

:host([status=idle]) .calcite-input-message-icon {
  color: var(--calcite-color-brand);
}

:host([scale=s]) {
  font-size: var(--calcite-font-size--3);
  line-height: 0.75rem;
}

:host([scale=m]) {
  font-size: var(--calcite-font-size--2);
  line-height: 1rem;
}

:host([scale=l]) {
  font-size: var(--calcite-font-size--1);
  line-height: 1rem;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}